<template>
<div class="vs-component vs-con-input-label vs-input w-full vs-input-dark">
  <form-label v-if="label !== ''">{{ label }}</form-label>
    <div class="vs-con-input">
      <vue-numeric 
        class="vs-inputx vs-input--input normal hasValue" 
        :currency="currencySymbol"
        :thousand-separator="useThousandSeparator ? ',' : ''" 
        :minus="minus"
        :precision="precision"
        v-on:input="updateInput"
        :value="value"></vue-numeric>
    </div>
    <span v-if="comparedValue">
      <span class="span-text-validation span-text-validation-success vs-input--text-validation-span">
        <div class="con-text-validation vs-input--text-validation ml-2"> {{ formattedComparedValue }}
          <feather-icon :icon=" comparedValue < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[comparedValue < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 pt-1']"></feather-icon>
        </div>
      </span>
    </span>
  </div>
</template>
<script>
import {
  FormLabel
} from "../../../shared/components";
import VueNumeric from 'vue-numeric';

export default ({
  components: {
    VueNumeric,
    FormLabel
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    previous: {
      type: Number
    },
    value: {
      type: Number,
      required: true
    },
    name: {
      default: "",
      type: String
    },
    minus: {
      type: Boolean,
      default : false
    },
    currencySymbol : {
      type: String,
      default: ''
    },
    precision : {
      type: Number,
      default: 0
    },
    useThousandSeparator : {
      type: Boolean,
      default: true
    }
  },
  computed : {
    comparedValue() {
      if (this.previous !== null && this.previous !== undefined) {
        return this.value - this.previous;
      } else {
        return null;
      }
    },
    formattedComparedValue() {
      if (this.comparedValue !== undefined && this.comparedValue !== null) {
        let diff = this.$props.useThousandSeparator === true ? this.comparedValue.toLocaleString('en-US') : this.comparedValue;
        if (this.comparedValue > 0) {
          diff = "+" + diff.toString();
        }
        return this.$t("Previous") + " : " + this.$props.useThousandSeparator === true ? this.previous.toLocaleString('en-US') : this.previous + " (" + diff + ")";
      } else {
        return "";
      }
    }
  },
  methods: {
    updateInput(value) {
      this.$emit("input", value);
    }
  }
})
</script>
